import React from "react";
import { AppBar, Toolbar, Typography, Button, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";

function FileManagementAppBar({ handleSignOut }) {
  const location = useLocation();
  const navigate = useNavigate();

  const isFileManager = location.pathname === "/file-manager";

  const handleBackClick = () => {
    navigate("/dashboard");
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundImage:
          "linear-gradient(to right, rgba(32, 32, 32, 100), rgba(32, 32, 32, 0.98))",
      }}
    >
      <Toolbar>
        {isFileManager && (
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleBackClick}
            sx={{ mr: 2 }}
          >
            <ArrowBackIcon />
          </IconButton>
        )}
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          User Dashboard
        </Typography>
        <Button color="inherit" onClick={handleSignOut}>
          Sign Out
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default FileManagementAppBar;
